import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { site } from "../data/site";
import { useT } from "../data/i18n";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { lang, setLang, t } = useT();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  const nav = [
    { to: "/", label: t("nav_home"), k: "home" },
    { to: "/carta", label: t("nav_menu"), k: "menu" },
    { to: "/sobre-nosotros", label: t("nav_about"), k: "about" },
    { to: "/blog", label: t("nav_blog"), k: "blog" },
    { to: "/contacto", label: t("nav_contact"), k: "contact" },
  ];
  const LangSwitcher = () => (
    <div className="lang-switch" data-testid="lang-switch">
      {["es","ca","ar"].map((L) => (
        <button key={L} className={lang===L?"on":""} onClick={()=>setLang(L)} data-testid={`lang-${L}`}>{L.toUpperCase()}</button>
      ))}
    </div>
  );

  return (
    <>
      <header className={`header ${scrolled ? "scrolled" : ""}`} data-testid="site-header">
        <Link to="/" className="header-logo" data-testid="header-logo-link">
          Yasmina <span className="dot" />
        </Link>

        <nav data-testid="header-nav">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              className={({ isActive }) => (isActive ? "active" : "")}
              data-testid={`nav-${n.k}`}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <LangSwitcher />
          <a href={site.mapLink} target="_blank" rel="noreferrer" className="btn" data-testid="header-reserve-btn">
            {t("btn_map")}
          </a>
        </div>

        <button
          className="hamburger"
          onClick={() => setOpen(!open)}
          data-testid="header-hamburger"
          aria-label="Menú"
        >
          <span /><span /><span />
        </button>
      </header>

      {open && (
        <div className="mobile-menu" data-testid="mobile-menu">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.to === "/"}>{n.label}</NavLink>
          ))}
          <a href={site.mapLink} target="_blank" rel="noreferrer" className="btn primary">
            {t("btn_map")}
          </a>
          <LangSwitcher />
        </div>
      )}
    </>
  );
};
